






































































// vue
import {
    defineComponent,
    onMounted,
    onUnmounted,
    ref,
    watch,
} from '@vue/composition-api';

// hoooks
import { useGeoRecordModify } from '@/vue3/hooks/geoRecordModifyHook';
import { useGeoRecord } from '@/vue3/hooks/geoRecordHook';

// primevue
import Button from 'primevue/button';
import Panel from 'primevue/panel';
import InputNumber from 'primevue/inputnumber';
import InputSwitch from 'primevue/inputswitch';

// config
import Tools from '@/vue3/configs/multiModifyToolsConfig';
import { ActiveMultiModifyRecordTool, GeoRecord } from '@/vue3/api/models';

export default defineComponent({
    components: {
        Button,
        Panel,
        InputNumber,
        InputSwitch,
    },
    props: {
        mapbox: {
            type: Object,
            default: () => {},
        },
        clearGeoRecordSelection: {
            type: Function,
            default: () => {},
        },
        saveGeoRecords: {
            type: Function,
            default: () => {},
        },
        geoRecordsArray: {
            type: Array,
            defaul: [],
        },
        isGeomModificationActivated: {
            type: Boolean,
            default: false,
        },
        isModifyAllowed: {
            type: Boolean,
            default: false,
        },
    },
    setup(props: any, vm: any) {
        // hooks
        const { drawMutipleModify } = useGeoRecordModify();
        const { addGeoRecord } = useGeoRecord();

        // refs
        const isRotateFromAxis = ref(false);
        const isRotateToolSelected = ref(true);

        const rotationAngle = ref(0);

        const activeTool = ref<ActiveMultiModifyRecordTool>({
            activeToolName: '',
            activeToolDesc: '',
        });

        // methods
        const getRotationValue = (): void => {
            rotationAngle.value =
                props.mapbox.draw.getAll().features[0].properties.rotation;
        };

        const onToolChange = (tool: any): void => {
            activeTool.value = {
                activeToolName: tool.name,
                activeToolDesc: tool.description,
            };

            if (activeTool.value.activeToolName === 'Translate') {
                props.mapbox.map.off('mousemove', getRotationValue);

                if (!props.isGeomModificationActivated) return;

                startTranslateMode();
                return;
            }

            props.mapbox.map.on('mousemove', getRotationValue);
            startRotateMode();
        };

        const addModifyLayer = (): void => {
            drawMutipleModify(props.mapbox.draw, props.geoRecordsArray);
        };

        const startTranslateMode = (): void => {
            if (!props.isGeomModificationActivated) return;
            addModifyLayer();

            props.mapbox.draw.changeMode('DrawTranslateMode', {
                featureIds: [
                    ...props.geoRecordsArray.map((geoRecord) => geoRecord.id),
                ],
            });
        };

        const startRotateMode = (): void => {
            if (!props.isGeomModificationActivated) return;

            addModifyLayer();

            props.mapbox.draw.changeMode('drawRotateMode', {
                selectedFeatures: [
                    ...props.geoRecordsArray.map((geoRecord) => geoRecord.id),
                ],
                isRotateFromAxis: isRotateFromAxis.value,
            });
        };

        const onNonSimilarGeomFound = (): void => {
            isRotateFromAxis.value = false;

            vm.root.$notify({
                group: 'foo',
                type: 'error',
                title: 'Error rotating',
                text: `Please select similar geometry type to rotate from scale center.`,
            });
        };

        const onRotateFromScale = (): void => {
            if (activeTool.value.activeToolName !== 'Rotate') return;

            props.geoRecordsArray.every((geoRecord: GeoRecord) => {
                if (
                    geoRecord.geometry.type !==
                    props.geoRecordsArray[0].geometry.type
                ) {
                    onNonSimilarGeomFound();
                    return false;
                }
                return true;
            });

            props.mapbox.draw.deleteAll();

            startRotateMode();
        };

        const saveWithEnterKey = (event) => {
            if (event.key === 'Enter') {
                props.saveGeoRecords();
                props.clearGeoRecordSelection();
            }
        };

        // watcher
        watch(
            () => props.isGeomModificationActivated,
            () => {
                onToolChange(Tools[0]);
                startTranslateMode();
            },
        );

        // lifecycle
        onMounted(() => {
            onToolChange(Tools[0]);

            window.addEventListener('keydown', saveWithEnterKey);
        });

        onUnmounted(() => {
            props.mapbox.draw.changeMode('simple_select');
            props.mapbox.map.off('mousemove', getRotationValue);

            window.removeEventListener('keydown', saveWithEnterKey);

            props.geoRecordsArray.forEach((geoRecord) => {
                addGeoRecord(props.mapbox.map, geoRecord);
            });
        });

        return {
            Tools,
            activeTool,
            isRotateToolSelected,
            rotationAngle,
            isRotateFromAxis,
            onToolChange,
            startTranslateMode,
            startRotateMode,
            onRotateFromScale,
        };
    },
});
